import { RENTALS_SORT_TYPES, TP } from '../../constants/consts';

export const getKeyOfTranslateBySortSlug = slug => {
  switch (slug) {
    case RENTALS_SORT_TYPES.WORK_NAME:
      return `${TP}.FN_PRODUCTION_CARD_HEADER_WORK`;

    case RENTALS_SORT_TYPES.COMPOSER_NAME:
      return `${TP}.m_COMPOSER`;

    case RENTALS_SORT_TYPES.COMPANY_NAME:
      return `${TP}.m_COMPANY`;

    case RENTALS_SORT_TYPES.DIRECTOR_NAME:
      return `${TP}.m_PRODUCER`;

    case RENTALS_SORT_TYPES.CONDUCTOR_NAME:
      return `${TP}.m_CONDUCTOR`;

    case RENTALS_SORT_TYPES.DATE_FROM:
      return `${TP}.m_DATE_FROM`;

    case RENTALS_SORT_TYPES.DATE_TO:
      return `${TP}.FN_DATE_TO`;

    case RENTALS_SORT_TYPES.REFRESH_DATE:
      return `${TP}.m_REFRESH_DATE`;

    default:
      return `${TP}.m_NO_VALUE`;
  }
};
